import { ChangeDetectionStrategy, Component, EventEmitter, Input, Output } from '@angular/core';
import { IShopUserAddress } from '@x/ecommerce/shop-client';

@Component({
  selector: 'x-region-user-addresses',
  templateUrl: './region-user-addresses.component.html',
  changeDetection: ChangeDetectionStrategy.OnPush,
  host: {
    class: 'x-region-user-addresses',
  },
})
export class RegionUserAddressesComponent {
  @Input() addresses: IShopUserAddress[] = [];

  @Output() addressSelected = new EventEmitter<IShopUserAddress>();

  onSelectedSavedAddress(address: IShopUserAddress) {
    this.addressSelected.emit(address);
  }
}
